import { Grid, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { DetailTable } from "../../../../components/detail_table";
import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IExpense } from "../../data/entities";
import { expenseRedux } from "../state/state";

export const ExpenseDetailPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const { id } = match.params;
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(expenseRedux.actions.getDetail(id));
  }, [dispatch, id]);
  const expenseDetailBranch = useSelector<IAppReduxState, IAsyncData<IExpense>>((state) => state.expense.details);

  const deleteExpense = async (id: string): Promise<void> => {
    await dispatch(expenseRedux.actions.delete(id));
    history.push(ROUTES.expense);
  };
  const deleteBranch = useSelector<IAppReduxState, IAsyncData<void>>((state) => state.expense.delete);

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <DetailTable
          branch={expenseDetailBranch}
          route={ROUTES.expense}
          onDelete={deleteExpense}
          deleteBranch={deleteBranch}
        >
          <Table size="medium" className="detail-table">
            <TableBody>
              <TableRow>
                <TableCell>Ad</TableCell>
                <TableCell>{expenseDetailBranch.data?.name}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DetailTable>
      </Grid>
    </Grid>
  );
};
